import * as types from './constants';


export const toggleSidebar = () => ({
  type: types.LAYOUT_TOGGLE_SIDEBAR
})

